import { render, staticRenderFns } from "./dealeOrderReview.vue?vue&type=template&id=9f41bf64&scoped=true&"
import script from "./dealeOrderReview.vue?vue&type=script&lang=js&"
export * from "./dealeOrderReview.vue?vue&type=script&lang=js&"
import style0 from "./dealeOrderReview.vue?vue&type=style&index=0&id=9f41bf64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f41bf64",
  null
  
)

export default component.exports